import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  pairingCode: () => faker.lorem.word(),
  cancelUnattendedRecurringMeeting: false,
  roomCheckInEnabled: false,
  onsiteRoomRecaptureEnabled: true,
  roomResizerEnabled: true,
  settingsAccessCode: '1234',
  devicesTimeFormat: 'STANDARD',

  withGoogleCalendar: trait({
    afterCreate(company, server) {
      server.create('roomba/connection', { company, provider: 'GOOGLE' });
    },
  }),
});
